<template>
  <div>
    <Header
      :title="$t('mapping.mappingCreate').toString()"
      :items="headerButtons"
      :show-back-button="true"
      @back="$router.push({ name: 'projectMappingsMappings' })"
      @save="saveMapping"
    />
    <div class="card card-custom">
      <div class="card-body">
        <FormHelper
          ref="form"
          v-model="mapping"
          :form="form"
          :config="config"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataStructures from "@/components/DataStructures/dataStructures";
import Mapping from "@/components/Mappings/mapping";
import { mapActions, mapGetters } from "vuex";
import Header from "@/components/Tools/Header/Header.vue";
import FormHelper from "@/components/Tools/FormHelper/FormHelper.vue";
import {
  addEventToLoadingQueue,
  removeEventFromLoadingQueue
} from "@/composables/useLoadingQueue";
import { useCurrentProjectFilter } from "@/composables/useCurrentProjectFilter";
import { REMOVE_MAPPING_FIELDS } from "@/core/services/store/mapping.module";

export default {
  components: { FormHelper, Header },
  props: {},
  data() {
    return {
      headerButtons: [
        {
          type: "button",
          title: this.$t("general.save"),
          emit: "save"
        }
      ],
      config: {
        snippetPrefix: "assignments",
        enableVariables: false
      },
      form: [
        {
          label: this.$t("mapping.mappingLabel"),
          name: "label",
          type: "text",
          disableReturnType: true,
          default: "",
          validations: {
            required: true,
            minLength: 3
          }
        },
        {
          label: this.$t("mapping.mappingDescription"),
          name: "description",
          type: "textarea",
          default: "",
          validations: {
            required: false
          }
        },
        {
          label: this.$t("mapping.projects"),
          name: "projects",
          type: "multiselect",
          clearable: true,
          options: [],
          validations: {
            required: true
          }
        },
        {
          label: this.$t("mapping.mappingDataStructureSource"),
          name: "source_data_structure_id",
          type: "select",
          options: this.dataStructures,
          validations: {
            required: true
          }
        },
        {
          label: this.$t("mapping.mappingDataStructureTarget"),
          name: "target_data_structure_id",
          type: "select",
          options: [],
          validations: {
            required: true
          }
        }
      ],
      mapping: {
        label: "",
        description: "",
        source_data_structure_id: undefined,
        target_data_structure_id: undefined,
        projects: []
      }
    };
  },
  computed: {
    ...mapGetters(["projects", "selectedProject"])
  },
  watch: {
    selectedProject: function () {
      this.loadDataStructures();
      this.getProjectOptions();
    }
  },
  mounted() {
    this.getProjectOptions();
    this.mapping.projects = [this.selectedProject.id];
    this.loadDataStructures();
  },
  methods: {
    ...mapActions("mapping", [REMOVE_MAPPING_FIELDS]),
    getProjectOptions() {
      // Fills multiselect projects
      const formProjects = Object.values(this.form).find(
        element => element.name === "projects"
      );
      formProjects.options = this.projects?.length
        ? this.projects.map(project => {
            return {
              label: project.name,
              value: project.id
            };
          })
        : [];
    },
    getDataStructureOptions(dataStructures) {
      const formDataStructureSource = Object.values(this.form).find(
        element => element.name === "source_data_structure_id"
      );

      const formDataStructureTarget = Object.values(this.form).find(
        element => element.name === "target_data_structure_id"
      );

      const options = dataStructures.map(item => ({
        label: item.label,
        value: item.id
      }));

      formDataStructureSource.options = options;
      formDataStructureTarget.options = options;
    },
    loadDataStructures() {
      addEventToLoadingQueue({ key: "loadDataStructures" });
      let params = {
        noPagination: true
      };
      const { filter } = useCurrentProjectFilter();

      DataStructures.getAll(params, filter.value)
        .then(response => {
          this.getDataStructureOptions(response.data);
          removeEventFromLoadingQueue({ key: "loadDataStructures" });
        })
        .catch(error => {
          this.$error(error);
        });
    },
    saveMapping() {
      addEventToLoadingQueue({ key: "saveDataStructures" });

      if (
        this.mapping.source_data_structure_id ===
        this.mapping.target_data_structure_id
      ) {
        removeEventFromLoadingQueue({
          key: "saveDataStructures",
          type: "error",
          prefix: "mapping",
          name: "useDifferentDataStructures"
        });

        return;
      }
      this[REMOVE_MAPPING_FIELDS](this.mapping);
      Mapping.store(this.mapping)
        .then(response => {
          removeEventFromLoadingQueue({
            key: "saveDataStructures",
            type: "success",
            prefix: "mapping",
            name: "mappingSaved"
          });
          this.$router.push({
            name: "projectMappingsMappingMapper",
            params: { id: response.data.id }
          });
        })
        .catch(error => {
          this.$error(error);
        });
    }
  }
};
</script>
